import React, { useState, useEffect } from 'react';
import axios from 'services/axios_config';
import { getDefaults, saveDefaults,changeDefaults } from 'services/login';
import cloneDeep from 'lodash/cloneDeep';
import { getUserImage, sendErrorsToServer } from 'services/user';
import { message } from 'antd';
import TokenExpired from 'components/TokenExpired';


export const AppContext = React.createContext();

const AppContextProvider = ({ children }) => {

    // console.count('AppContextProvider')

    

    const [messageApi, contextHolder] = message.useMessage();


    const [accessToken, setAccessToken] = useState(null);
    const [defaults, setDefaults] = useState(null);
    const [asideIsVisible, setAsideIsVisible] = useState(true);
    const [currentLocation, setCurrentLocation] = useState(['1']);
    const [helpNavIsVisible, setHelpNavIsVisible] = useState(false);
    const [userImg, setUserImg] = useState(null);
    const [isModalExport, setIsModalExport] = useState(false);

    const [userSubscribe, setUserSubscribe] = useState(false);
    const [mainUserDetailsDrawerIsVisible, setMainUserDetailsDrawerIsVisible] =
        useState(false);

    const [analysisTableChartDisplay, setAnalysisTableChartDisplay] =
        // useState('tablechart');
        // useState('table');
        useState('table');

    //     const [sendErr, setSendErr] = useState(false)

    //     let dataToSendErrors = {}


    //     window.onerror = (message, url, lineNumber) => {
    //         console.log(`message: ${message}`);
    //         console.log(`url: ${url}`);
    //         console.log(`lineNumber: ${lineNumber}`);
    //         dataToSendErrors = {'message': message, 'url': url, 'lineNumber':lineNumber}
    //         setSendErr(true)
    //       };

          
        

    // useEffect(()=>{
    //     if(sendErr){
    //         sendErrorsToServer(dataToSendErrors)
    //     }
    // },[sendErr])


    useEffect(() => {
        if (accessToken == null) syncTokenFromSessionStore();
    }, [accessToken]);

    const fillDefaults = (newDefaults) => {
        newDefaults = newDefaults[0];
        let localDefaults = {};
        for (let d in newDefaults) {
            if (d == 'defaults') {
                let objDefaults = newDefaults[d];
                for (let dd in objDefaults) {
                    localDefaults[objDefaults[dd]['name']] =
                        objDefaults[dd]['value'];
                }
            } else {
                if (d == 'user_img' && userImg != newDefaults[d])
                    setUserImg(newDefaults[d]);
                localDefaults[d] = newDefaults[d];
            }
        }
        setDefaults(localDefaults);
    };

    const setDefault = (name, value) => {
        console.log(`setDefaults`, name, value)
        let localDefaults = cloneDeep(defaults);
        localDefaults[name] = value;
        setDefaults(localDefaults);

        console.log(`localDefaults`, localDefaults)

        const data = {
            name: name,
            value: value
        };

        if(sessionStorage.getItem('onboarding_home') || sessionStorage.getItem('onboarding_project') || sessionStorage.getItem('onboarding_home')){
            if(name == 'onboarding_home'){
                changeDefaults(Number(sessionStorage.getItem('onboarding_home')), data)
            }else if(name == 'onboarding_project') {
                changeDefaults(Number(sessionStorage.getItem('onboarding_project')), data)
            }else if(name == 'sub_go_pro') {
                changeDefaults(Number(sessionStorage.getItem('sub_go_pro')), data)
            }
        }else {
            saveDefaults(data).then((res) => {});
        }
        
    };

    // saveDefaults({ name: 'successfull_upload_popup', value: false });

    const syncTokenFromSessionStore = () => {
        const token = sessionStorage.getItem('accessToken');
        if (token && token !== '' && token !== undefined) {
            setAccessToken(token);
            getDefaults().then((result) => {
                console.log(`resData:`,result.data[0].defaults.find(el=> el.name === 'onboarding_home') )
                fillDefaults(result.data);
                // sessionStorage.setItem('latest_commit',result.data[0].latest_commit);
                // =================================
                // Start set sessionStorage obnoarding: 
                let idOnboardingHome = result.data[0]?.defaults.find(el=> el.name === 'onboarding_home')
                sessionStorage.setItem('onboarding_home', idOnboardingHome.id )
                let idOnboardingProject = result.data[0]?.defaults.find(el=> el.name === 'onboarding_project')
                sessionStorage.setItem('onboarding_project', idOnboardingProject.id )
                // ====================================
                // End set sessionStorage obnoarding: 
                let idSubGoPro = result.data[0]?.defaults.find(el=> el.name === 'sub_go_pro')
                sessionStorage.setItem('sub_go_pro', idSubGoPro.id )

                compareCommits(result.data[0].latest_commit)
            });
        }
    };

    const setAccessTokenSessionStore = (newAccessToken) => {
        if (newAccessToken) {
            sessionStorage.setItem('accessToken', newAccessToken);
            axios.defaults.headers.common[
                'Authorization'
            ] = `Bearer ${newAccessToken}`;
            setAccessToken(newAccessToken);

            getDefaults().then((result) => {
                fillDefaults(result.data);
                sessionStorage.setItem('latest_commit',result.data[0].latest_commit);
            });
        } else {
            sessionStorage.removeItem('accessToken');
            axios.defaults.headers.common['Authorization'] = newAccessToken;
            setAccessToken(newAccessToken);
        }
    };

    const compareCommits = (latest_commit) => {
        if (latest_commit !== sessionStorage.getItem('latest_commit')) {
            sessionStorage.setItem('latest_commit', latest_commit);
            window.location.reload(true);
        }
    }

    const logOut = () => {
        setAccessTokenSessionStore(null);
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/app/login/';
    };

    const appSettings = {
        accessToken: accessToken,
        setAccessTokenSessionStore,
        syncTokenFromSessionStore,
        logOut,
        analysisTableChartDisplay: analysisTableChartDisplay,
        setAnalysisTableChartDisplay,
        defaults: defaults,
        setDefault,
        userSubscribe: userSubscribe,
        setUserSubscribe,
        currentLocation: currentLocation,
        setCurrentLocation,
        mainUserDetailsDrawerIsVisible: mainUserDetailsDrawerIsVisible,
        setMainUserDetailsDrawerIsVisible,
        asideIsVisible: asideIsVisible,
        setAsideIsVisible,
        helpNavIsVisible: helpNavIsVisible,
        setHelpNavIsVisible,
        userImg: userImg,
        setUserImg,
        isModalExport: isModalExport,
        setIsModalExport
    };

    return (
        <>
            <AppContext.Provider value={appSettings}>
                {accessToken? <TokenExpired setAccessTokenSessionStore={setAccessTokenSessionStore}/>:null }
                
            {/* {contextHolder} */}

                {children}
            </AppContext.Provider>
        </>
    );
};

export default AppContextProvider;
